import { Typography } from '@mui/material';
import { useShowContext } from 'framework/show';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';
import { getOutcomeActiveForText, OutcomeActiveForInput } from './getOutcomeActiveFor';

const OutcomeActiveForField = () => {
  const { data } = useShowContext();

  const text = getOutcomeActiveForText(data as OutcomeActiveForInput);

  return <Typography color="textSecondary">{text ?? EMPTY_VALUE_INDICATOR}</Typography>;
};

export default OutcomeActiveForField;
